import i18n from 'i18n-react';

import { ContentHeader } from 'components/ContentHeader/ContentHeader';
import { FastFacts } from 'components/FastFacts/FastFacts';
import SocialIcons from 'components/SocialIcons/SocialIcons';

import { useFeatureFlag } from 'hooks/useFeatureFlag';

export function FastFactsView() {
  const isAmbassador = useFeatureFlag('ambassador');

  const headerText = isAmbassador ? i18n.translate('ambassador.nav.promote') : i18n.translate('nav.promote');

  return (
    <div className="contentContainer fast-facts-view" data-testid="fast-facts-view">
      <ContentHeader
        header={headerText}
        subtitle={i18n.translate(isAmbassador ? 'pageDescriptions.promoteAmbassador' : 'pageDescriptions.promote')}
        pageHeader
        line
      >
        <SocialIcons />
      </ContentHeader>
      <FastFacts />
    </div>
  );
}
